<template>
    <lx-dialog :is-visible-dialog.sync="isVisibleDialog" :width="'960px'" :top="'2vh'" is-custome-footer @close="doCancel">
        <span slot="title" class="lx-fz16">{{title}}</span>
        <div class="lx-temp lx-flex">
            <div class="lx-form-wrap lx-flex-grow-1">
                <lx-form>
                    <!-- 模板名称 -->
                    <lx-form-item :label="$t('laund.laund3')+':'" :labelWidth="'200px'" :error="error.name" required>
                        <div class="lx-inline-flex-row">
                            <lx-input id="name" v-model.trim="form.name" type="text" :size="'auto'" :width="'176px'" :height="'28px'" :maxlength="15" @blur="onBlur('name', true)"></lx-input>
                            <div class="lx-input-count">
                                <span class="lx-input-count-name">{{$t('laund.laund26')}}{{form.name.length}}</span> / <span>15</span>
                            </div>
                        </div>
                    </lx-form-item>
                    <!-- 备注 -->
                    <lx-form-item :label="$t('laund.laund19')+':'" :labelWidth="'200px'" :error="error.remarks">
                        <div class="lx-inline-flex-row">
                            <lx-input id="remarks" v-model.trim="form.remarks" type="text" :size="'auto'" :width="'176px'" :height="'28px'" :maxlength="15" @blur="onBlur('remarks', false)"></lx-input>
                            <div class="lx-input-count">
                                <span class="lx-input-count-remarks">{{$t('laund.laund26')}}{{form.remarks.length}}</span> / <span>15</span>
                            </div>
                        </div>
                    </lx-form-item>
                    <!-- 尺寸 -->
                    <lx-form-item :label="$t('laund.laund11')+':'" :labelWidth="'200px'" :error="error.size">
                        <div class="lx-inline-flex-row">
                            <lx-input id="size" v-model.trim="form.size" type="text" :size="'auto'" :width="'176px'" :height="'28px'" :maxlength="5" @blur="onBlur('size', false)"></lx-input>
                            <div class="lx-input-count">
                                <span class="lx-input-count-size">{{$t('laund.laund26')}}{{form.size.length}}</span> / <span>6</span>
                            </div>
                        </div>
                    </lx-form-item>
                    <!-- 材质 -->
                    <lx-form-item :label="$t('laund.laund12')+':'" :labelWidth="'200px'" align="normal" :error="error.material" required>
                        <div class="lx-inline-flex">
                            <textarea class="lx-textarea" id="material" name="material" rows="4" :maxlength="48" v-model="form.material" required @input="onInputMaterial" @blur="onBlur('material', true)"></textarea>
                            <div class="lx-pt2">
                                <div class="lx-input-count">
                                    <span class="lx-input-count-material">{{$t('laund.laund26')}}{{form.material.length}}</span> / <span>48</span>
                                </div>
                                <div class="lx-input-row lx-mt4" :class="{active: isMmaterialRows}">
                                    <span class="lx-input-row-material">&nbsp;&nbsp;&nbsp;{{$t('laund.laund27')}}{{materialRows}}</span> / <span>4</span>
                                </div>
                            </div>
                        </div>
                    </lx-form-item>
                    <!-- 使用注意事项 -->
                    <lx-form-item :label="$t('laund.laund28')+':'" :labelWidth="'200px'" align="normal" :error="error.notes">
                        <div class="lx-inline-flex">
                            <textarea class="lx-textarea" id="notes" name="notes" rows="8" :maxlength="96" v-model="form.notes" @input="onInputNotes" @blur="onBlur('notes', false)"></textarea>
                            <div class="lx-pt2">
                                <div class="lx-input-count">
                                    <span class="lx-input-count-notes">{{$t('laund.laund26')}}{{form.notes.length}}</span> / <span>96</span>
                                </div>
                                <div class="lx-input-row lx-mt4" :class="{active: isNotesRows}">
                                    <span class="lx-input-row-notes">&nbsp;&nbsp;&nbsp;{{$t('laund.laund27')}}{{notesRows}}</span> / <span>8</span>
                                </div>
                            </div>
                        </div>
                    </lx-form-item>
                    <!-- 公司名 -->
                    <lx-form-item :label="$t('laund.laund29')+':'" :labelWidth="'200px'" align="normal" :error="error.company" required>
                        <div class="lx-inline-flex">
                            <textarea class="lx-textarea" id="company" name="company" rows="2" :maxlength="24" v-model="form.company" required @input="onInputCompany" @blur="onBlur('company', true)"></textarea>
                            <div class="lx-pt2">
                                <div class="lx-input-count">
                                    <span class="lx-input-count-company">{{$t('laund.laund26')}}{{form.company.length}}</span> / <span>24</span>
                                </div>
                                <div class="lx-input-row lx-mt4" :class="{active: isCompanyRows}">
                                    <span class="lx-input-row-company">&nbsp;&nbsp;&nbsp;{{$t('laund.laund27')}}{{companyRows}}</span> / <span>2</span>
                                </div>
                            </div>
                        </div>
                    </lx-form-item>
                    <!-- 联系电话 -->
                    <!-- <lx-form-item :label="$t('laund.laund30')+':'" :labelWidth="'200px'" :error="error.telephone" required>
                        <div class="lx-inline-flex-row">
                            <lx-input id="telephone" v-model.trim="form.telephone" type="text" :size="'auto'" :width="'176px'" :height="'28px'" :maxlength="15" @blur="onBlur('telephone', true)"></lx-input>
                            <div class="lx-input-count">
                                <span class="lx-input-count-telephone">{{$t('laund.laund26')}}{{form.telephone.length}}</span> / <span>15</span>
                            </div>
                        </div>
                    </lx-form-item> -->
                    <!-- Email -->
                    <!-- <lx-form-item label="Email:" :labelWidth="'200px'" align="normal" :error="error.email">
                        <div class="lx-inline-flex">
                            <textarea class="lx-textarea" id="email" name="email" rows="3" :maxlength="40" v-model="form.email" @input="onInputEmail" @blur="onBlur('email', false)"></textarea>
                            <div class="lx-pt2">
                                <div class="lx-input-count">
                                    <span class="lx-input-count-email">{{$t('laund.laund26')}}{{form.email.length}}</span> / <span>40</span>
                                </div>
                                <div class="lx-input-row lx-mt4" :class="{active: isEmailRows}">
                                    <span class="lx-input-row-email">&nbsp;&nbsp;&nbsp;{{$t('laund.laund27')}}{{emailRows}}</span> / <span>3</span>
                                </div>
                            </div>
                        </div>
                    </lx-form-item> -->
                    <lx-form-item :label="$t('laund.laund46')+':'" :labelWidth="'200px'" align="normal" :error="error.residence" required>
                        <div class="lx-inline-flex">
                            <textarea class="lx-textarea" id="residence" name="residence" rows="7" :maxlength="80" v-model="form.residence" @input="onInputResidence" @blur="onBlur('residence', true)"></textarea>
                            <div class="lx-pt2">
                                <div class="lx-input-count">
                                    <span class="lx-input-count-residence">{{$t('laund.laund26')}}{{form.residence.length}}</span> / <span>80</span>
                                </div>
                                <div class="lx-input-row lx-mt4" :class="{active: isResidenceRows}">
                                    <span class="lx-input-row-residence">&nbsp;&nbsp;&nbsp;{{$t('laund.laund27')}}{{residenceRows}}</span> / <span>7</span>
                                </div>
                            </div>
                        </div>
                    </lx-form-item>
                    <lx-form-item :label="$t('laund.laund31')+':'" :labelWidth="'200px'">
                        <div class="lx-text-second">{{$t('laund.laund44')}}</div>
                    </lx-form-item>
                    <lx-form-item :label="' '" :labelWidth="'200px'">
                        <div class="lx-sign-container">
                            <div class="lx-sign-wrap">
                                <div class="lx-sign-title asterisk">{{$t('laund.laund32')}}</div>
                                <div class="lx-sign-img lx-sign-img-icon1 lx-flex-row lx-flex-wrap">
                                    <div class="lx-sign-img-item lx-fz0" :class="{active: curIcon1Index === index}" v-for="(item, index) in icon1s" :key="index" @click="onSelectImg(item, index, 'icon1', 'curIcon1Index', true)">
                                        <img class="lx-img" :src='item.url'>
                                    </div>
                                </div>
                                <div class="lx-invalid-feedback">{{error.icon1}}</div>
                            </div>
                            <div class="lx-sign-wrap">
                                <div class="lx-sign-title asterisk">
                                    {{$t('laund.laund33')}}
                                </div>
                                <div class="lx-sign-img lx-sign-img-icon2 lx-flex-row lx-flex-wrap">
                                    <div class="lx-sign-img-item lx-fz0" :class="{active: curIcon2Index === index}" v-for="(item, index) in icon2s" :key="index" @click="onSelectImg(item, index, 'icon2', 'curIcon2Index', true)">
                                        <img class="lx-img" :src='item.url'>
                                    </div>
                                </div>
                                <div class="lx-invalid-feedback">{{error.icon2}}</div>
                            </div>
                            <div class="lx-sign-wrap">
                                <div class="lx-sign-title asterisk">
                                    {{$t('laund.laund34')}}
                                </div>
                                <div class="lx-sign-img lx-sign-img-icon3 lx-flex-row lx-flex-wrap">
                                    <div class="lx-sign-img-item lx-fz0" :class="{active: curIcon3Index === index}" v-for="(item, index) in icon3s" :key="index" @click="onSelectImg(item, index, 'icon3', 'curIcon3Index', true)">
                                        <img class="lx-img" :src='item.url'>
                                    </div>
                                </div>
                                <div class="lx-invalid-feedback">{{error.icon3}}</div>
                            </div>
                            <div class="lx-sign-wrap">
                                <div class="lx-sign-title asterisk">
                                    {{$t('laund.laund35')}}
                                </div>
                                <div class="lx-sign-img lx-sign-img-icon4 lx-flex-row lx-flex-wrap">
                                    <div class="lx-sign-img-item lx-fz0" :class="{active: curIcon4Index === index}" v-for="(item, index) in icon4s" :key="index" @click="onSelectImg(item, index, 'icon4', 'curIcon4Index', true)">
                                        <img class="lx-img" :src='item.url'>
                                    </div>
                                </div>
                                <div class="lx-invalid-feedback">{{error.icon4}}</div>
                            </div>
                            <div class="lx-sign-wrap">
                                <div class="lx-sign-title asterisk">
                                    {{$t('laund.laund36')}}
                                </div>
                                <div class="lx-sign-img lx-sign-img-icon5 lx-flex-row lx-flex-wrap">
                                    <div class="lx-sign-img-item lx-fz0" :class="{active: curIcon5Index === index}" v-for="(item, index) in icon5s" :key="index" @click="onSelectImg(item, index, 'icon5', 'curIcon5Index', true)">
                                        <img class="lx-img" :src='item.url'>
                                    </div>
                                </div>
                                <div class="lx-invalid-feedback">{{error.icon5}}</div>
                            </div>
                            <div class="lx-sign-wrap">
                                <div class="lx-sign-title">
                                    {{$t('laund.laund37')}}
                                </div>
                                <div class="lx-sign-img lx-sign-img-icon6 lx-flex-row lx-flex-wrap">
                                    <div class="lx-sign-img-item lx-fz0" :class="{active: curIcon6Index === index}" v-for="(item, index) in icon6s" :key="index" @click="onSelectImg(item, index, 'icon6', 'curIcon6Index', false)">
                                        <img class="lx-img" :src='item.url'>
                                    </div>
                                </div>
                            </div>
                            <div class="lx-sign-wrap">
                                <div class="lx-sign-title">
                                    {{$t('laund.laund38')}}
                                </div>
                                <div class="lx-sign-img lx-sign-img-icon7 lx-flex-row lx-flex-wrap">
                                    <div class="lx-sign-img-item lx-fz0" :class="{active: curIcon7Index === index}" v-for="(item, index) in icon7s" :key="index" @click="onSelectImg(item, index, 'icon7', 'curIcon7Index', false)">
                                        <img class="lx-img" :src='item.url'>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </lx-form-item>
                </lx-form>
            </div>

            <!-- 右侧预览 -->
            <div class="temp-wrapper lx-flex-shrink-0">
                <div class="temp-header">{{$t('laund.laund39')}}</div>
                <div class="temp-main">
                    <div class="temp-main-top lx-hidden" :style="{height: tempHeight}">
                        <div ref="topInner" class="topInner" v-resize="resetHeight">
                            <section class="seat"></section>
                            <section class="lx-section lx-mb5 temp-no">
                                <span class="temp-title">NO.</span>
                                <span class="temp-content">******</span>
                            </section>
                            <section class="lx-section lx-flex-row lx-mb15 temp-size" v-if="form.size">
                                <div class="temp-title" style="margin-bottom: 0">サイズ:</div>
                                <span class="temp-content">{{form.size}}</span>
                            </section>
                            <section class="lx-section lx-mb15 temp-material">
                                <div class="temp-title">品質表示:</div>
                                <span class="temp-content pre-line">{{form.material}}</span>
                            </section>
                            <section class="lx-section temp-material">
                                <!-- <div class="temp-title">洗濯表示記号:</div> -->
                                <div class="temp-icon-wrap">
                                    <img v-if="iconUrl.icon1" :src="iconUrl.icon1" class="temp-img temp-icon1">
                                    <img v-if="iconUrl.icon2" :src="iconUrl.icon2" class="temp-img temp-icon2">
                                    <img v-if="iconUrl.icon3" :src="iconUrl.icon3" class="temp-img temp-icon3">
                                    <img v-if="iconUrl.icon4" :src="iconUrl.icon4" class="temp-img temp-icon4">
                                    <img v-if="iconUrl.icon5" :src="iconUrl.icon5" class="temp-img temp-icon5">
                                    <img v-if="iconUrl.icon6" :src="iconUrl.icon6" class="temp-img temp-icon6">
                                    <img v-if="iconUrl.icon7" :src="iconUrl.icon7" class="temp-img temp-icon7">
                                </div>
                            </section>
                        </div>
                    </div>
                    <div class="temp-main-bottom lx-hidden" :style="{height: tempHeight}">
                        <div ref="bottomInner" class="bottomInner" v-resize="resetHeight">
                            <!-- 注意事项 -->
                            <section class="lx-section lx-mb15 temp-notes">
                                <span class="temp-content pre-line">{{form.notes}}</span>
                            </section>
                            <!-- 公司名 -->
                            <section class="lx-section lx-text-center lx-mb15 temp-company" v-if="form.company">
                                <span class="temp-content pre-line">{{form.company}}</span>
                            </section>
                            <!-- <section class="lx-section lx-text-center lx-mb15 temp-telephone" v-if="form.telephone">
                                <span class="temp-content">{{form.telephone}}</span>
                            </section>
                            <section class="lx-section lx-text-center lx-mb15 temp-email" v-if="form.email">
                                <span class="temp-content pre-line">{{form.email}}</span>
                            </section> -->
                            <section class="lx-section lx-mb15 temp-residence" v-if="form.residence">
                                <span class="temp-content pre-line">{{form.residence}}</span>
                            </section>
                            <section class="lx-section lx-text-center lx-mb15">
                                <span class="temp-content">MADE IN CHINA</span>
                            </section>
                            <section class="seat"></section>
                        </div>
                    </div>
                </div>
                <div class="temp-footer lx-flex-row-between lx-mt10">
                    <el-button class="search-btn btn-gray" @click="doCancel">{{$t('cancel')}}</el-button>
                    <el-button class="search-btn btn-green" :disabled="isLoading" :loading="isLoading" @click="doConfirm">{{$t('confirm')}}</el-button>
                </div>
            </div>
        </div>
    </lx-dialog>
</template>
<script>
import LxDialog from "@/components/LxDialog/index";
import LxForm from "@/components/LxForm/index";
import LxFormItem from "@/components/LxFormItem/index";
import LxInput from "@/components/LxInput/index";
import { checkEmpty } from "@/assets/js/utils.js";
import {
    icon1s,
    icon2s,
    icon3s,
    icon4s,
    icon5s,
    icon6s,
    icon7s,
} from "./imgUrl";
import resize from '@/directives/resize'

export default {
    name: "LxTemp",
    components: {
        LxDialog,
        LxForm,
        LxFormItem,
        LxInput,
    },
    directives: {
        resize
    },
    props: {
        title: {
            type: String,
            default: "标题",
        },
        visible: {
            type: Boolean,
            default: false,
        },
        id: {
            type: [Number, String],
            default: "",
        },
        tempType: {
            type: String,
            default: "",
        },
    },
    computed: {
        isVisibleDialog: {
            get() {
                return this.visible;
            },
            set(val) {
                this.$emit("update:visible", val);
            },
        },
    },
    watch: {
        visible(val) {
            if (val && this.id) {
                this.form.id = this.id;
                this.getTempInfo(this.id);
            } else if (!val) {
                this.resetTemp();
            }
        },
    },
    data() {
        return {
            isLoading: false,
            info: {},
            isOnly: false,
            form: {
                name: "", // 模板名称
                remarks: "", // 备注
                size: "", // 尺寸
                material: "", // 材质
                notes: "", // 使用注意事项
                company: "", // 公司名
                // telephone: "", // 联系电话
                // email: "", // Email
                residence: '', // 住所
                icon1: "",
                icon2: "",
                icon3: "",
                icon4: "",
                icon5: "",
                icon6: "",
                icon7: "",
            },
            error: {
                name: "",
                remarks: "",
                size: "",
                material: "", // 材质
                notes: "", // 使用注意事项
                company: "", // 公司名
                // telephone: "", // 联系电话
                // email: "", // Email
                residence: '', // 住所
                icon1: "",
                icon2: "",
                icon3: "",
                icon4: "",
                icon5: "",
            }, // error提示信息
            iconUrl: {
                icon1: "",
                icon2: "",
                icon3: "",
                icon4: "",
                icon5: "",
                icon6: "",
                icon7: "",
            }, // 右边模板显示的图片本地路径
            materialRows: 0, // 材质行数
            isMmaterialRows: false, // 超出规定行数
            notesRows: 0, // 使用注意事项行数
            isNotesRows: false, // // 超出规定行数
            companyRows: 0, // 公司名行数
            isCompanyRows: false, // // 超出规定行数
            // emailRows: 0,
            // isEmailRows: false, // // 超出规定行数
            residenceRows: 0,
            isResidenceRows: false, // 住所
            curIcon1Index: null,
            icon1s,
            curIcon2Index: null,
            icon2s,
            curIcon3Index: null,
            icon3s,
            curIcon4Index: null,
            icon4s,
            curIcon5Index: null,
            icon5s,
            curIcon6Index: null,
            icon6s,
            curIcon7Index: null,
            icon7s,
            tempHeight: 'auto',
        };
    },
    methods: {
        getTempInfo(id) {
            const url = `laundry/label/template/info/${id}`;
            this.$http.get(url, {}).then((res) => {
                let info = res.data.data;
                this.info = info;
                Object.keys(this.form).forEach((key) => {
                    this.form[key] = info[key];
                });
                for (let index = 1; index < 8; index++) {
                    if (info[`icon${index}`]) {
                        this.renderTempImg(
                            this[`icon${index}s`],
                            `icon${index}`,
                            info[`icon${index}`],
                            index
                        );
                    }
                }
            });
        },

        renderTempImg(list, key, value, index) {
            this.iconUrl[key] = list.find((item) => item.value === value).url;
            this[`curIcon${index}Index`] = list.findIndex(
                (item) => item.value === value
            );
        },
        // 失去焦点校验
        onBlur(name, require) {
            const data = this.form;
            if (require) this.checkValEmpty(data, name)
            // if (require && this.checkValEmpty(data, name)) {
            //     this.checkValFormat(data, name);
            // }
            if (name == "name" && this.form.name) {
                this.checkOnly();
            }
        },
        /**
         * 校验空值
         */
        checkValEmpty(data = {}, name = "") {
            if (
                name == "remarks" ||
                name == "size" ||
                name == "icon6" ||
                name == "icon7" ||
                name == "notes"
            ) {
                return true;
            } else {
                const tip = this.$t('laund.laund45');
                if (!checkEmpty(data[name]) && name) {
                    this.error[name] = tip;
                    return false;
                } else {
                    this.error[name] = "";
                    return true;
                }
            }
        },
        /**
         * 校验行数
         */
        checkValRows() {
            const tip = this.$t('laund.laund40');
            if (this.isMmaterialRows) {
                this.error["material"] = tip;
                return false;
            }else if (this.isCompanyRows) {
                this.error["company"] = tip;
                return false;
            } else if (this.isResidenceRows) {
                this.error["residence"] = tip;
                return false;
            } else {
                return true;
            }
        },

        /**
         * 校验格式
         */
        // checkValFormat(data = {}, name = "") {
        //     if (name === "email") {
        //         if (!this.checkEmail(data[name])) {
        //             this.error[name] = this.$t('laund.laund41');
        //             return false;
        //         } else {
        //             this.error[name] = "";
        //             return true;
        //         }
        //     } else {
        //         return true;
        //     }
        // },

        // 模板名称唯一性校验
        checkOnly() {
            return new Promise((resolve, reject) => {
                const tip =this.$t('laund.laund42');
                const params = {
                    name: this.form.name,
                    id: this.tempType == "edit" ? this.info.id : "",
                };
                const url = "laundry/label/template/checkName";
                this.$http
                    .post(url, params)
                    .then((res) => {
                        if (res.data.code == 200) {
                            this.isOnly = true;
                            this.error.name = "";
                            resolve(true);
                        } else {
                            this.isOnly = false;
                            this.error.name = tip;
                            this.isLoading = false;
                            reject(false);
                        }
                    })
                    .catch(() => {
                        this.isOnly = false;
                        this.error.name = tip;
                        this.isLoading = false;
                        reject(false);
                    });
            });
        },
        // checkEmail(val) {
        //     if (!val) return true;
        //     let str = "";
        //     val.split("\n").forEach((item) => (str += item.trim()));
        //     const REG =
        //         /^[A-Za-z0-9\u4E00-\u9FA5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
        //     if (REG.test(str)) {
        //         return true;
        //     } else {
        //         return false;
        //     }
        // },

        // 计算材质行数
        onInputMaterial() {
            let rows = 0;
            const maxRows = 4;
            const val = this.form.material;
            const len = val.length;
            const maxlength = 48;
            this.getRows(val, maxRows, 12, (res, row) => {
                if (res) {
                    if ((maxlength > len || maxlength == len) && len > 0) {
                        this.isMmaterialRows = false;
                        rows = row;
                        this.error["material"] = "";
                    }
                } else {
                    this.isMmaterialRows = true;
                    rows = row;
                    this.error["material"] = this.$t('laund.laund40');
                }
            });
            this.materialRows = rows;
        },
        // 计算注意事项行数
        onInputNotes() {
            let rows = 0;
            const maxRows = 8;
            const val = this.form.notes;
            const len = val.length;
            const maxlength = 96;
            this.getRows(val, maxRows, 12, (res, row) => {
                if (res) {
                    if ((maxlength > len || maxlength == len) && len > 0) {
                        this.isNotesRows = false;
                        rows = row;
                        this.error["notes"] = "";
                    }
                } else {
                    this.isNotesRows = true;
                    rows = row;
                    this.error["notes"] = this.$t('laund.laund40');
                }
            });
            this.notesRows = rows;
        },
        // 计算公司名行数
        onInputCompany() {
            let rows = 0;
            const maxRows = 2;
            const val = this.form.company;
            const len = val.length;
            const maxlength = 24;
            this.getRows(val, maxRows, 12, (res, row) => {
                if (res) {
                    if ((maxlength > len || maxlength == len) && len > 0) {
                        this.isCompanyRows = false;
                        rows = row;
                        this.error["company"] = "";
                    }
                } else {
                    this.isCompanyRows = true;
                    rows = row;
                    this.error["company"] = this.$t('laund.laund40');
                }
            });
            this.companyRows = rows;
        },
        // 计算email行数
        // onInputEmail() {
        //     let rows = 0;
        //     const maxRows = 3;
        //     const val = this.form.email;
        //     const len = val.length;
        //     const maxlength = 40;
        //     this.getRows(val, maxRows, 15, (res, row) => {
        //         if (res) {
        //             if ((maxlength > len || maxlength == len) && len > 0) {
        //                 this.isEmailRows = false;
        //                 rows = row;
        //                 this.error["email"] = "";
        //             }
        //         } else {
        //             this.isEmailRows = true;
        //             rows = row;
        //             this.error["email"] = this.$t('laund.laund40');
        //         }
        //     });
        //     this.emailRows = rows;
        // },
        // 计算住所行数
        onInputResidence() {
            let rows = 0;
            const maxRows = 7;
            const val = this.form.residence;
            const len = val.length;
            const maxlength = 80;
            this.getRows(val, maxRows, 12, (res, row) => {
                if (res) {
                    if ((maxlength > len || maxlength == len) && len > 0) {
                        this.isResidenceRows = false;
                        rows = row;
                        this.error["residence"] = "";
                    }
                } else {
                    this.isResidenceRows = true;
                    rows = row;
                    this.error["residence"] = this.$t('laund.laund40');
                }
            });
            this.residenceRows = rows;
        },
        // 计算行数
        getRows(val, maxRows, column = 12, callback) {
            if (val) {
                let list = val.split("\n");
                let row = list.length;
                list.forEach((item) => {
                    row = list.length === 1 && item.length > column ? Math.ceil(item.length/column) : item.length > column ? row + 1 : row
                });
                if (row > maxRows) {
                    typeof callback === "function" && callback(false, row);
                } else {
                    typeof callback === "function" && callback(true, row);
                }
            } else {
                typeof callback === "function" && callback(true, 0);
            }
        },

        // 选择洗涤符号
        onSelectImg(item, index, key, curIndex, require) {
            if (require) {
                this[curIndex] = index;
                this.form[key] = item.value;
                this.error[key] = "";
                this.iconUrl[key] = item.url;
            } else {
                if (this[curIndex] === index) {
                    this[curIndex] = null;
                    this.form[key] = "";
                    this.iconUrl[key] = "";
                } else {
                    this[curIndex] = index;
                    this.form[key] = item.value;
                    this.iconUrl[key] = item.url;
                }
            }
        },
        /**
         * 点击提交时的校验
         */
        async validate(data = {}) {
            const valids = [];
            for (const key in data) {
                if (Object.hasOwnProperty.call(data, key)) {
                    const resultEmpty = await this.checkValEmpty(data, key);
                    valids.push(resultEmpty);
                    const resultRows = await this.checkValRows();
                    valids.push(resultRows);
                    // const resultFormat = await this.checkValFormat(data, key);
                    // valids.push(resultFormat);
                }
            }
            if (valids.includes(false)) {
                this.isLoading = false;
                return false;
            } else {
                return true;
            }
        },
        /**
         * 提交表单
         */
        async doConfirm() {
            this.isLoading = true;
            const resultOnly = await this.checkOnly();
            if (!resultOnly) return false;
            this.validate(this.form).then((valid) => {
                if (valid) {
                    const url = "laundry/label/template/insertAndEdit";
                    const params = this._.cloneDeep(this.form);
                    this.tempType == "edit"
                        ? (params.id = this.info.id)
                        : (params.id = "");
                    this.$http
                        .post(url, params)
                        .then((res) => {
                            this.$message({
                                type: "success",
                                message: res.data.message,
                            });
                            this.$emit("success");
                            this.isLoading = false;
                        })
                        .catch(() => {
                            this.$message({
                                type: "error",
                                message: this.$t('laund.laund43'),
                            });
                            this.isLoading = false;
                        });
                } else {
                    this.isLoading = false;
                }
            });
        },
        doCancel() {
            this.isVisibleDialog = false;
        },
        resetTemp() {
            Object.keys(this.form).forEach((key) => {
                this.form[key] = "";
                this.error[key] = "";
                this.iconUrl[key] = "";
            });
            for (let index = 1; index < 8; index++) {
                this[`curIcon${index}Index`] = null;
            }
        },
        resetHeight() {
            const tempTopHeight = this.$refs.topInner.clientHeight
            const tempBottomHeight = this.$refs.bottomInner.clientHeight
            this.tempHeight = tempTopHeight > tempBottomHeight ? `${tempTopHeight}px` : `${tempBottomHeight}px`
        }
    },
};
</script>
<style lang="scss" scoped>
.lx-temp {
    height: 858px;
    overflow: hidden;
    .lx-form-wrap {
        height: 100%;
        overflow-y: auto;
        padding: 15px 30px 15px 0;
        &::-webkit-scrollbar {
            width: 5px;
        }
        .lx-textarea {
            width: 176px;
            border: 1px solid #c3c3c3;
            border-radius: 3px;
            margin: 0;
            box-sizing: border-box;
            padding: 4px 5px;
            resize: none;
            outline: none;
            font-size: 13px;
            letter-spacing: -0.5px;
            &::-webkit-scrollbar {
                width: 0;
            }
        }
        .lx-input-count,
        .lx-input-row {
            flex-shrink: 0;
            margin-left: 12px;
            color: #999;
            font-size: 12px;
            span {
                font-size: inherit;
            }
            &.active {
                color: #900;
                span {
                    color: #900;
                }
            }
        }
    }
    .lx-text-second {
        color: #999;
    }
    .seat {
        height: 30px;
    }
    .lx-sign-container {
        .lx-sign-wrap {
            position: relative;
            margin-bottom: 35px;
        }
        .lx-sign-title {
            font-size: 16px;
            font-weight: bold;
            color: #333;
            margin-bottom: 12px;
        }

        .lx-sign-img-item {
            margin-right: 10px;
            margin-bottom: 10px;
            border: 2px solid transparent;
        }
        .lx-sign-img-item.active {
            border-color: #0d8ddb;
            border-radius: 3px;
            overflow: hidden;
            box-shadow: -5px -5px 10px 1px rgba(0, 0, 0, 0.05);
        }
        .lx-sign-img-item:hover {
            cursor: pointer;
        }
        .lx-sign-img-item .lx-img {
            width: 50px;
            height: 50px;
        }
    }

    .temp-wrapper {
        width: 250px;
        padding: 0 30px;
        background-color: #fff;
        box-sizing: border-box;
        overflow-y: auto;
    }
    .temp-header {
        color: #333;
        font-weight: bold;
        font-size: 15px;
        margin: 10px 0;
    }
    .temp-main {
        display: flex;
        flex-direction: column;
        width: 176px;
        // height: 720px;
        border: 1px solid #333;
        border-radius: 2px;
        box-sizing: content-box;
        padding: 10px 0;
    }
    .temp-main-top,
    .temp-main-bottom {
        flex-shrink: 0;
        padding: 0 10px;
    }
    .temp-main-bottom {
        padding-top: 10px;
    }
    .temp-icon-wrap {
        margin-top: 10px;
    }
    .temp-title {
        color: #333;
        font-size: 13px;
        font-weight: bold;
        margin-bottom: 6px;
    }
    .temp-content {
        font-size: 13px;
        word-break: break-word;
    }
    .temp-img {
        width: 25px;
        height: 25px;
        margin-right: 6px;
        margin-bottom: 6px;
    }
    .temp-img:nth-child(5) {
        margin-right: 0;
    }
    .temp-footer {
        width: 176px;
        margin-bottom: 10px;
    }
    .temp-footer .btn {
        min-width: 70px;
        max-width: 75px;
        overflow: hidden;
    }
    .lx-section {
        height: auto;
        overflow: visible;
        font-size: 13px;
    }
    .pre-line {
        white-space: pre-line;
    }
}
::v-deep .lx-dialog-header {
    height: 50px;
}
::v-deep .lx-form-item {
    margin-bottom: 25px;
}
::v-deep .lx-label {
    text-align: right;
    font-weight: 700;
    font-size: 13px;
    color: #676a6c;
}
::v-deep .el-dialog__body {
    background-color: #f3f3f4;
    padding: 0;
}
::v-deep .el-dialog__footer {
    padding-bottom: 0;
}
::v-deep .lx-dialog-main {
    padding-left: 0;
    padding-right: 0;
}
::v-deep .lx-input-wrap .lx-input {
    padding-left: 0;
    padding-right: 0;
    font-size: 13px;
}

.lx-invalid-feedback {
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    padding: 0;
    color: #fd7778;
    margin-top: 2px;
    box-sizing: border-box;
    font-size: 12px;
}
</style>
